import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { prefillChangeRequest } from '../../lib/prefillChangeRequest'
import { selectWelcomeFlowUserData } from '../selectors'
import { IWelcomeFlowPartner } from '../types'

const getDefaultChangeRequest = () => ({}) as IFormJBPHPContactChangeRequest

export const usePrefilledChangeRequest = () => {
  const [changeRequest, setChangeRequest] =
    useState<IFormJBPHPContactChangeRequest>(getDefaultChangeRequest())

  const userData = useSelector(selectWelcomeFlowUserData)

  const createPrefilledAddRequest = useCallback(
    (partnerId: string, partnerName: string) => {
      const [role] = userData.Roles.split(',')
      setChangeRequest({
        ...prefillChangeRequest(userData, partnerId),
        Roles: role,
        BusinessUnit: userData.BusinessUnit || '',
        PartnerName: partnerName,
        RequestAction: 'Add',
      })
    },
    [userData]
  )

  const createPrefilledRemoveRequest = useCallback(
    (partner: IWelcomeFlowPartner) => {
      setChangeRequest({
        ...prefillChangeRequest(userData, partner.PartnerId),
        LeadPBM: partner.STLeadPBM ? 1 : 0,
        BusinessUnit: partner.STBusinessUnit || '',
        Roles: partner.STRole,
        PartnerName: partner.PartnerName,
        RequestAction: 'Delete',
      })
    },
    [userData]
  )

  const createPrefilledUpdateRequest = useCallback(
    (partner: IWelcomeFlowPartner) => {
      setChangeRequest({
        ...prefillChangeRequest(userData, partner.PartnerId),
        LeadPBM: partner.STLeadPBM ? 1 : 0,
        BusinessUnit: partner.STBusinessUnit || '',
        Roles: partner.STRole,
        PartnerName: partner.PartnerName,
        RequestAction: 'Update',
      })
    },
    [userData]
  )

  const resetPrefilledChangeRequest = useCallback(
    () => setChangeRequest(getDefaultChangeRequest()),
    []
  )

  return {
    changeRequest,
    createPrefilledAddRequest,
    createPrefilledRemoveRequest,
    createPrefilledUpdateRequest,
    resetPrefilledChangeRequest,
  }
}
